import Country from '~/Api/Country/Country';

export default class DataSource {
	type: string;

	country: Country;

	shortName: string;

	description: string;

	constructor(type: string, country: Country, shortName: string, description: string) {
		this.type = type;
		this.country = country;
		this.shortName = shortName;
		this.description = description;
	}
}
